import { render, staticRenderFns } from "./Treeview.vue?vue&type=template&id=2279d092&"
import script from "./Treeview.vue?vue&type=script&lang=js&"
export * from "./Treeview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\MasterBranches\\Maintenance_06.04\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2279d092')) {
      api.createRecord('2279d092', component.options)
    } else {
      api.reload('2279d092', component.options)
    }
    module.hot.accept("./Treeview.vue?vue&type=template&id=2279d092&", function () {
      api.rerender('2279d092', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Wes/Treeview.vue"
export default component.exports